import React from "react"
import { format } from "d3-format"
import { scaleLinear } from "d3-scale"
import { extent } from "d3-array"

import gradient from "../utils/gradient"

import "./styles.scss"

const formatter = format(".2f")

function getXScale(ticks, width) {
  const padding = {
    left: width * 0.1875,
    right: width * 0.225,
  }
  const xScale = scaleLinear()
    .domain(extent(ticks))
    .range([padding.left, width - padding.right])
  return { xScale, padding }
}

function SVGGradient() {
  const domain = gradient.domain()
  return (
    <linearGradient id="rainbowGradient">
      {domain.map((d, i) => (
        <stop
          key={d}
          offset={`${(i / (domain.length - 1)) * 100}%`}
          stopColor={gradient(d)}
        />
      ))}
    </linearGradient>
  )
}
const sideLabelY = 1
function LegendContainer(props) {
  const { width, height, children, padding } = props
  return (
    <svg className="Legend" width={width} height={height}>
      <text
        x={(width - padding.right - padding.left) / 2 + padding.left}
        y={height / 6}
        textAnchor="middle"
      >
        Adherence to the Rule of Law
      </text>
      <g transform={`translate(0, ${height / 2})`}>
        <text textAnchor="start" x={-5} y={sideLabelY}>
          Weaker
        </text>
        <text x={width + 5} textAnchor="end" y={sideLabelY}>
          Stronger
        </text>
        {children}
      </g>
    </svg>
  )
}

export function RadiusLegend(props) {
  const { width, height, scale, rScale } = props
  const ticks = rScale.ticks(8)
  const { xScale, padding } = getXScale(ticks, width)

  return (
    <LegendContainer width={width} height={height} padding={padding}>
      {ticks.map((t, i) => (
        <g key={t} transform={`translate(${xScale(t)}, 0)`}>
          <circle r={rScale(t) * scale} fill={gradient(t)} />
          {i === 0 || i === ticks.length - 1 ? (
            <text y={height / 3} textAnchor="middle">
              {formatter(t)}
            </text>
          ) : null}
        </g>
      ))}
    </LegendContainer>
  )
}

export function GradientLegend(props) {
  const { width, height } = props
  const ticks = [0, 0.25, 0.5, 0.75, 1]
  const { xScale, padding } = getXScale(ticks, width)

  return (
    <LegendContainer width={width} height={height} padding={padding}>
      <defs>
        <SVGGradient />
      </defs>
      <rect
        fill={`url(#rainbowGradient)`}
        x={padding.left}
        y={-height / 6}
        width={width - (padding.left + padding.right)}
        height={height / 3.25}
      />
      {ticks.map((t, i) => (
        <g key={t} transform={`translate(${xScale(t)}, 0)`}>
          <text y={height / 3} textAnchor="middle">
            {formatter(t)}
          </text>
        </g>
      ))}
    </LegendContainer>
  )
}

export function PercentChangeLegend(props) {
  const { width, height, percentChangeScale } = props
  // const ticks = [0, 0.25, 0.5, 0.75, 1];
  // const { xScale, padding } = getXScale(ticks, width);
  const ticks = [
    { value: -4, label: "≤-4%" },
    { value: -2, label: "-4% – -2%" },
    { value: 0, label: "-2% – 0%" },
    { value: 2, label: "0% – 2%" },
    { value: 4, label: "2% – 4%" },
    { value: 5, label: "≥4%" },
  ]

  const padding = {
    left: 65,
    right: 65,
  }

  const availWidth = width - padding.left - padding.right
  const tickWidth = availWidth / ticks.length
  const tickPadding = 5
  return (
    <svg className="Legend" width={width} height={height}>
      <text
        x={(width - padding.right - padding.left) / 2 + padding.left}
        y={height / 6}
        textAnchor="middle"
      >
        Overall rule of law score changes
      </text>
      <g transform={`translate(0, ${height / 2})`}>
        <text textAnchor="start" x={-5} y={sideLabelY}>
          Declining
        </text>
        <text
          x={availWidth + 5 + padding.left + tickWidth + tickPadding * 2}
          textAnchor="end"
          y={sideLabelY}
        >
          Improving
        </text>
        {ticks.map((t, i) => (
          <g
            key={t.value}
            transform={`translate(${padding.left + tickWidth * i}, 0)`}
          >
            <rect
              y={-height / 6}
              width={tickWidth - tickPadding * 2}
              x={tickPadding}
              height={height / 3.25}
              fill={percentChangeScale(t.value)}
            />
            <text y={height / 3} x={tickWidth * 0.5} textAnchor="middle">
              {t.label}
            </text>
          </g>
        ))}
      </g>
    </svg>
  )
}
